import { observer } from "mobx-react-lite";
import { registerView, ViewComponent } from "@frui.ts/views/dist";
import * as React from "react";
import Button from "@edaz/edazkit/Button";
import TradingPlaces from "@edaz/edazkit/TradingPlaces";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";
import { useWindowWidth } from "@react-hook/window-size";
import TradingPlacesViewModel from "../../viewModels/tradingPlaces/tradingPlacesViewModel";
import { googleMapsApiKey } from "../../config";
import TradingPlaceInfoView from "./components/tradingPlaceInfoView";
import LoadingPane from "../../controls/loadingPane";
import TradingPlacesAutosuggest from "./components/tradingPlacesAutosuggest";
import RoadLayerSelection from "./components/roadLayerSelection";
import RoadMapTooltip from "./components/roadMapTooltip";
import RoadMapViewModel from "../../viewModels/tradingPlaces/roadMapViewModel";
import MobileFilter from "./components/mobileFilter";
import KioskViewModel from "../../viewModels/tradingPlaces/kioskViewModel";

function calculateOffset() {
  let offsetY = 0;
  let offsetX = 0;

  if (window.innerWidth <= 450) {
    offsetY = -240;
  } else if (window.innerWidth <= 800) {
    offsetY = 0;
    offsetX = 180;
  }

  return {
    offsetX,
    offsetY,
  };
}

const TradingPlacesView: ViewComponent<TradingPlacesViewModel | RoadMapViewModel> = observer(({ vm }) => {
  const offset = calculateOffset();
  const currentWidth = useWindowWidth();

  if (!vm.showMap) {
    return (
      <div className={vm.mapButtonContainerClassName}>
        <Button variant="danger" onClick={vm.onShowMapClick} className={vm.mapButtonClassName}>
          {vm.mapButtonTitle}
        </Button>
      </div>
    );
  }

  const mobileBranchLink =
    vm.localizationService.locale === "cs"
      ? "https://www.ceskaposta.cz/cs/mobilni-posta"
      : "https://www.ceskaposta.cz/en/mobilni-posta";

  const mobileView = currentWidth <= 767;

  return (
    <div className="position-relative">
      {vm.showMap ? (
        <>
          {googleMapsApiKey && (
            <LoaderOverlay loader={<LoadingPane />} loading={vm.busyWatcher.isBusy}>
              <TradingPlaces
                places={vm.placesCoords}
                apiKey={googleMapsApiKey!}
                defaultZoom={7}
                centerYOffset={offset.offsetY}
                centerXOffset={offset.offsetX}
                radius={100}
                choosenPlace={vm.place?.id}
                choosePlace={vm.choosePlace}
                center={[49.90547, 15.278731]}
                mapHeight={686}
                options={{ fullscreenControl: false }}
                onGoogleApiLoaded={vm.onGoogleApiLoaded}
              />
            </LoaderOverlay>
          )}
          {!vm.mobileFilterOpen && (
            <div className="over-map">
              {vm.place ? (
                <TradingPlaceInfoView vm={vm} mobileView={mobileView} />
              ) : (
                <TradingPlacesAutosuggest
                  placeholder={vm.localizationService.translateGeneral("tradingPlaces.searchTradingPlaces")}
                  notFoundMessage={vm.localizationService.translateGeneral("tradingPlaces.tradingPlaceNotFound")}
                  vm={vm}
                  mobileView={mobileView}
                />
              )}
            </div>
          )}
          {!mobileView && <RoadLayerSelection vm={vm} />}
          {mobileView && <MobileFilter vm={vm} />}
          <p className="fz-20 mt-4">
            {vm.translate("mobileBranchInformation")}:&nbsp;
            <a href={mobileBranchLink} target="_blank" rel="noreferrer">
              {mobileBranchLink}
            </a>
          </p>
          <RoadMapTooltip roadData={vm.tooltipMessage} position={vm.tooltipPosition} show={vm.showTooltip} t={vm.translate} />
        </>
      ) : (
        <LoadingPane />
      )}
    </div>
  );
});

registerView(TradingPlacesView, TradingPlacesViewModel);
registerView(TradingPlacesView, RoadMapViewModel);
registerView(TradingPlacesView, KioskViewModel);
